<template>
  <div>
      <action-bar>
      </action-bar>
      <main class="content">
        <div v-if="subChapter">
            <h1>Unterkapitel bearbeiten<br>
                <small class="text-muted">
                  <router-link
                    v-if="chapter && chapter.keyThemeId"
                    :to="{name: 'key-theme-chapter-list', params: {keyThemeId: chapter.keyThemeId}}" exact>
                    {{keyTheme ? keyTheme.name.text : ''}}
                  </router-link>
                  <router-link
                    v-if="chapter && chapter.dossierId"
                    :to="{name: 'dossier-edit', params: {dossierId: chapter.dossierId}}" exact>
                    {{dossier ? dossier.name.text : ''}}
                  </router-link>
                  <i class="fal fa-angle-right"></i>
                  <router-link
                    :to="{name: 'synthesis-sub-chapter-list', params: {chapterId: subChapter.chapterId}}" exact>
                    {{chapter ? chapter.name.text : ''}}
                  </router-link>
                  <i class="fal fa-angle-right"></i>

                  {{subChapter.name.text}}</small>

            </h1>
            <ul class="nav nav-tabs">
              <li class="nav-item">
                  <router-link class="nav-link"
                              :to="{name: 'synthesis-sub-chapter-edit', params: {subChapterId: subChapter.id}}" exact>
                      Generelle Texte
                  </router-link>
              </li>
              <li class="nav-item">
                  <router-link class="nav-link"
                              :to="{name: 'synthesis-card-list', params: {subChapterId: subChapter.id}}" exact>
                      Karteikarten
                  </router-link>
              </li>
            </ul>
            <div class="tab-content">
                <router-view class="tab-pane fade show active" :data="subChapter" entity="subChapter"/>
            </div>
        </div>
        <loading v-else></loading>
      </main>
    </div>
</template>
<script>
export default {
  data() {
    return {
      subChapter: null
    };
  },
  asyncComputed: {
    keyTheme () {
      if (this.subChapter && this.subChapter.keyThemeId) {
        return axios
          .get('/api/' + store.state.language + '/key_theme/' + this.subChapter.keyThemeId)
          .then(({data}) => data.result)
      }
    },
    dossier () {
      if (this.subChapter && this.subChapter.dossierId) {
        return axios
          .get('/api/' + store.state.language + '/dossier/' + this.subChapter.dossierId)
          .then(({data}) => data.result)
      }
    },
    chapter () {
      if (this.subChapter) {
        return axios
          .get('/api/' + store.state.language + '/chapter/' + this.subChapter.chapterId)
          .then(({data}) => data.result)
      }
    },
  },
  mounted() {
    axios
      .get(
        "/api/" +
          store.state.language +
          "/sub_chapter/" +
          this.$route.params.subChapterId
      )
      .then(({ data }) => {
        this.subChapter = data.result;
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/synthesis/sub_chapter/Edit.vue